import { useEffect } from "react";

export default function useScrollReveal(deps = []) {
  useEffect(() => {
    const elements = document.querySelectorAll(
      ".scroll-reveal, .scroll-reveal-left, .scroll-reveal-right, .scroll-reveal-zoom, .scroll-reveal-glass, .scroll-reveal-opacity"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    elements.forEach((el) => {
      el.classList.remove("visible"); // 🔥 reset
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, deps);
}